/* eslint-disable */
'use client';

import { createNavigation } from 'next-intl/navigation';
import { defaultLocale, locales } from './configs/common';
import { defineRouting } from 'next-intl/routing';
import { notFound, ReadonlyURLSearchParams, useParams, useSearchParams, useServerInsertedHTML } from 'next/navigation';

export const routing = defineRouting({
    defaultLocale,
    localePrefix: 'as-needed',
    locales,
});
// This is where we fix the api gaps
// eslint-disable-next-line no-restricted-imports
export { useSearchParams, notFound, ReadonlyURLSearchParams, useServerInsertedHTML, useParams };

// @see https://next-intl-docs.vercel.app/docs/routing/navigation

export const { permanentRedirect, redirect, usePathname, useRouter } = createNavigation(routing);
